import { HomePageConfig } from 'store/remoteConfig/types';
import { pageTypes, pageNamePrefix } from 'shared/constants/dataLayer';
import { getErrorString } from 'store/dataLayer/helpers';
import { Inventory, FetchHomePageParams } from './types';
import { SEO_METADATA, SEO_DATA } from './constants';
import { PagePrefixes } from 'constants/pagePrefixes';

const widgetsPageType = 'mweb-homepage';

export const getHomePageParams = () => ({
  page_type: widgetsPageType,
  page_section: '*',
  device: 'mobile',
  dn_platform: 'mweb',
  //catalog_tag_filter: 'men',
});

export const getDataLayer = (
  errorCode: number | null,
  params: FetchHomePageParams
) => {
  const isLandingPage = params.isLandingPage;
  if (errorCode && errorCode > 200) {
    return {
      pageName: getErrorString(errorCode),
      pageType: isLandingPage ? params.page_type : pageTypes.HOME,
    };
  }

  if (isLandingPage) {
    return {
      pageName: `mWeb:nlp:${params.page_type || ''}:${
        params.page_data || 'default'
      }`,
      pageType: params.page_type || '',
    };
  }

  return {
    pageName: pageNamePrefix.HOME,
    pageType: pageTypes.HOME,
  };
};

export const getMetaData = (
  inventories: Inventory[],
  pagePrefix: string = ''
) => {
  const seoData = inventories.find(
    (x: Inventory) => x.widgetData && x.widgetData.widgetType === SEO_DATA
  );
  if (seoData) {
    let {
      widgetData: { params },
    } = seoData;
    params = {
      ...params,
      canonical:
        pagePrefix === PagePrefixes.SPECIAL_PAGE ? params.canonical : '',
    };
    return params;
  } else {
    return SEO_METADATA[__PLATFORM__];
  }
};

export const getCustomPageType = (
  homePageConfig: HomePageConfig,
  pageTypeInQuery: string | null
): string | null => {
  const { status, suffix } = homePageConfig.pageTypeSuffix || {};
  const { page_type } = getHomePageParams();

  if (status && suffix && suffix === pageTypeInQuery) {
    return `${page_type}-${suffix}`;
  }
  return null;
};
